var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-notice-detail"},[(_vm.noticeDetail)?_c('BoardDetail',{attrs:{"board-id":_vm.id,"board":_vm.noticeDetail,"list-path":"/customer/notice"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }